'use client'

import { useTranslations } from 'next-intl'

import { Link, usePathname } from '@/shared/i18n'
import { TextButton } from '@/shared/ui'

import { Layout } from '../layout'

type Props = {
  wide?: boolean
}

export const SimpleNavigationBarUI = ({ wide = false }: Props) => {
  const pathname = usePathname()
  const t = useTranslations('navigation')

  const showHostIntroButton = pathname === '/sign-in'

  return (
    <Layout wide={wide}>
      <div className="flex shrink-0 items-center justify-end gap-4">
        {showHostIntroButton && (
          <TextButton asChild color="gray" size="small" weight="normal">
            <Link href="/host/main" locale="ko">
              {t('start_to_landlord')}
            </Link>
          </TextButton>
        )}
      </div>
    </Layout>
  )
}
